import { useState } from 'react';
import { Icon } from './Visuals';

/** Hover previews on desktop; click, tap and keyboard toggle the same detail panel. */
export function ReasonPopover({reasons,topProspect=false,topExplanation,score}: {reasons:string[];topProspect?:boolean;topExplanation?:string;score:number}){
  const [hovered,setHovered]=useState(false);
  const [pinned,setPinned]=useState(false);
  const visible=hovered||pinned;
  const unique=[...new Set(reasons.map(reason=>reason.trim()).filter(Boolean))];
  return <div className="priorityReasonPopover" onPointerEnter={event=>{if(event.pointerType==='mouse')setHovered(true);}} onPointerLeave={()=>setHovered(false)} onBlur={event=>{if(!event.currentTarget.contains(event.relatedTarget))setPinned(false);}}>
    <button type="button" aria-label="Show why this prospect is recommended" aria-expanded={visible} onClick={()=>setPinned(open=>!open)}><Icon name="info"/>WHY</button>
    {visible&&<div className="priorityReasonPanel" role="note"><strong>{topProspect?'TOP PROSPECT · WHY':'WHY THIS PERSON'}</strong><span>Role fit · {score}%</span>
      {topProspect&&topExplanation&&<p>{topExplanation}</p>}
      {unique.length?<ul>{unique.slice(0,5).map(reason=><li key={reason}>{reason}</li>)}</ul>:<p>Relevant role according to current CRM fit criteria. Review the contact before preparing outreach.</p>}
      <small>Fit is a relevance estimate, not a prediction of a reply.</small>
    </div>}
  </div>;
}
